import { Component, OnInit, Input } from '@angular/core';
import { SetService, PageService } from 'ngx-block-core';
import { NzModalService } from 'ng-zorro-antd';
@Component({
  selector: 'app-sucu01-data0010003',
  templateUrl: './sucu01-data0010003.component.html',
  styleUrls: ['./sucu01-data0010003.component.less']
})
export class Sucu01Data0010003Component implements OnInit {

  constructor(public setService: SetService, private pageService: PageService, private modalService: NzModalService, ) { }

  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() sets = {
    blockCode: "sucublock56",
    blockId: "",
    blockName: "日志抽屉",
    layoutId: "",
    blockType: 'drawer',
    blockChildType: 'log',
    versionCode: 7,
    styles: {
      nzWidth: 15,
      nzWidthUnit: '%',//px %
      nzHeight: 50,
      nzHeight2: 30,
      nzShow2: false,
      nzHeightUnit: '%',//px %
      nzPosition: "left",
      nzPosition2: "left",
      nzMode: 'moreline',//oneline
      nzOffsetLeft: null,
      nzOffsetRight: null,
      nzOffsetTop: null,
      nzOffsetBottom: null,
      nzOffsetLeft2: null,
      nzOffsetRight2: null,
      nzOffsetTop2: null,
      nzOffsetBottom2: null,
      nzNeedClear: false,
      nzShowModal: false,
      nzStyles: {
        nzStatus: [
          {
            label: "失败",
            value: "fail",
            color: "rgba(255, 0, 0,0.99)",
            nzShowModal: true,
          },
          {
            label: "成功",
            value: "success",
            color: "#1890ff",
            nzShowModal: false,
          },
          // {
          //   label: "成功-重要",
          //   value: "success-pop",
          //   color: "#1890ff",
          //   nzShowModal: true,
          // },
          // {
          //   label: "失败-其它",
          //   value: "fail-other",
          //   color: "#1890ff",
          //   nzShowModal: false,
          // }
        ]
      }
    },
    datas: {
      nzLinkage: {
        nzUsed: false,
        nzEvents: [
        ],
      },
      nzLinkageData: {
      },

    }
  };
  source2: {
    id: string,
    title: string,
    state: string
  }[] = [
      // {
      //   id: '1',
      //   title: 'test1',
      //   state: "loading",//'check-circle'
      // },
      // {
      //   id: '2',
      //   title: 'test2',
      //   state: "success",//'check-circle'
      // },
      // {
      //   id: '3',
      //   title: 'test2',
      //   state: "fail",//'check-circle'
      // }
    ];
  source = [
    // {
    //   title: "12345",
    //   content: "操作成功",
    //   state: "success",
    //   defaultTitle: "SN：",
    //   msg: ""
    // },
    // {
    //   title: "67848",
    //   content: "操作失败",
    //   state: "fail",
    //   defaultTitle: "SN：",
    //   msg: "错误信息"
    // },
    // {
    //   title: "1234545",
    //   content: "操作成功",
    //   state: "success",
    //   defaultTitle: "SN：",
    //   msg: ""
    // },
    // {
    //   title: "6784832",
    //   content: "操作成功",
    //   defaultTitle: "SN：",
    //   state: "success",
    //   msg: ""
    // },
    // {
    //   title: "6667767646",
    //   content: "操作失败",
    //   defaultTitle: "SN：",
    //   state: "fail",
    //   msg: "错误信息"
    // },
    // {
    //   title: "12345",
    //   content: "操作成功",
    //   state: "success",
    //   defaultTitle: "SN：",
    //   msg: ""
    // },
    // {
    //   title: "67848",
    //   content: "操作失败",
    //   state: "fail",
    //   defaultTitle: "SN：",
    //   msg: "错误信息"
    // },
    // {
    //   title: "1234545",
    //   content: "操作成功",
    //   state: "success",
    //   defaultTitle: "SN：",
    //   msg: ""
    // },
    // {
    //   title: "6784832",
    //   content: "操作成功",
    //   defaultTitle: "SN：",
    //   state: "success",
    //   msg: ""
    // },
    // {
    //   title: "6667767646",
    //   content: "操作失败",
    //   defaultTitle: "SN：",
    //   state: "fail",
    //   msg: "错误信息"
    // }
    // ,
    // {
    //   title: "12345",
    //   content: "操作成功",
    //   state: "success",
    //   defaultTitle: "SN：",
    //   msg: ""
    // },
    // {
    //   title: "67848",
    //   content: "操作失败",
    //   state: "fail",
    //   defaultTitle: "SN：",
    //   msg: "错误信息"
    // },
    // {
    //   title: "1234545",
    //   content: "操作成功",
    //   state: "success",
    //   defaultTitle: "SN：",
    //   msg: ""
    // },
    // {
    //   title: "6784832",
    //   content: "操作成功",
    //   defaultTitle: "SN：",
    //   state: "success",
    //   msg: ""
    // },
    // {
    //   title: "6667767646",
    //   content: "操作失败",
    //   defaultTitle: "SN：",
    //   state: "fail",
    //   msg: "错误信息"
    // }
  ]
  setData = []

  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              {
                name: 'nzLinkage',
                inputs: {
                  nzKeyData: [{ value: 'goodsNum', label: '良' }, { value: 'badsNum', label: '不良' }]
                }
              },
            ],
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'radio',
                inputs: { nzText: "模式 : ", nzKeys: ['styles', 'nzMode'], nzData: [{ value: 'moreline', label: '多行' }, { value: 'oneline', label: '单行' }] }
              },
              {
                name: 'switch',
                inputs: { nzText: "需要清空 : ", nzKeys: ['styles', 'nzNeedClear'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "显示弹框 : ", nzKeys: ['styles', 'nzShowModal'] }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "宽度 : ", nzKeys: ['styles', 'nzWidth']
                }
              },
              {
                name: 'radio',
                inputs: { nzText: "宽度单位 : ", nzKeys: ['styles', 'nzWidthUnit'], nzData: [{ value: 'px', label: 'px' }, { value: '%', label: '百分比' }] }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "高度 : ", nzKeys: ['styles', 'nzHeight']
                }
              },
              {
                name: 'radio',
                inputs: { nzText: "高度单位 : ", nzKeys: ['styles', 'nzHeightUnit'], nzData: [{ value: 'px', label: 'px' }, { value: '%', label: '百分比' }] }
              },
              {
                name: 'select',
                inputs: { nzText: "位置 : ", nzKeys: ['styles', 'nzPosition'], nzData: [{ value: 'left', label: '左' }, { value: 'top', label: '上' }, { value: 'right', label: '右' }, { value: 'bottom', label: '下' }] }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "上间距 : ", nzKeys: ['styles', 'nzOffsetTop']
                }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "下间距 : ", nzKeys: ['styles', 'nzOffsetBottom']
                }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "左间距 : ", nzKeys: ['styles', 'nzOffsetLeft']
                }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "右间距 : ", nzKeys: ['styles', 'nzOffsetRight']
                }
              },
              {
                name: 'switch',
                inputs: { nzText: "显示2 : ", nzKeys: ['styles', 'nzShow2'] }
              },
              {
                name: 'select',
                inputs: { nzText: "位置2 : ", nzKeys: ['styles', 'nzPosition2'], nzData: [{ value: 'left', label: '左' }, { value: 'top', label: '上' }, { value: 'right', label: '右' }, { value: 'bottom', label: '下' }] }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "高度2 : ", nzKeys: ['styles', 'nzHeight2']
                }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "上间距2 : ", nzKeys: ['styles', 'nzOffsetTop2']
                }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "下间距2 : ", nzKeys: ['styles', 'nzOffsetBottom2']
                }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "左间距2 : ", nzKeys: ['styles', 'nzOffsetLeft2']
                }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "右间距2 : ", nzKeys: ['styles', 'nzOffsetRight2']
                }
              },
              {
                name: 'button',
                inputs: {
                  nzText: ["清除间距"]
                },
                outputs: {
                  onClick1: () => {
                    this.sets.styles.nzOffsetTop = null;
                    this.sets.styles.nzOffsetBottom = null;
                    this.sets.styles.nzOffsetLeft = null;
                    this.sets.styles.nzOffsetRight = null;
                  }
                }
              }, {
                name: 'nzDrawerState'
              }
            ]
          },
        ]
      },


    ]
  }
  typeList = [{
    label: "全部",
    value: "all"
  }]
  nzTypeItem = {
    label: "全部",
    value: "all"
  }
  statusData = {}
  ngOnInit() {
    this.baseInit();
    this.sets.styles.nzStyles.nzStatus.forEach(element => {
      this.typeList.push({
        label: element.label,
        value: element.value
      })
      this.statusData[element.value] = element;


    });
  }
  autoUpdate() {
    if (this.sets.versionCode < 2) {


      this.sets.styles.nzNeedClear = false;


      this.sets.versionCode = 2;
    }
    if (this.sets.versionCode < 3) {


      this.sets.styles.nzHeight = 600;
      this.sets.styles.nzHeightUnit = "px";
      this.sets.versionCode = 3;
    }
    if (this.sets.versionCode < 4) {


      this.sets.styles.nzShowModal = false;
      this.sets.versionCode = 4;
    }
    if (this.sets.versionCode < 5) {


      this.sets.styles.nzStyles = {
        nzStatus: [
          {
            label: "失败",
            value: "fail",
            color: "rgba(255, 0, 0,0.99)",
            nzShowModal: true,
          },
          {
            label: "成功",
            value: "success",
            color: "#1890ff",
            nzShowModal: false,
          }
        ]
      }
      this.sets.versionCode = 5;
    }
    if (this.sets.versionCode < 6) {


      this.sets.datas = {
        nzLinkage: {
          nzUsed: false,
          nzEvents: [
          ],
        },
        nzLinkageData: {
        },
      }
      this.sets.versionCode = 6;
    }
    if (this.sets.versionCode < 7) {


      this.sets.styles.nzHeight2 = 30;
      this.sets.styles.nzPosition2 = "left";
      this.sets.styles.nzOffsetLeft2 = null;
      this.sets.styles.nzOffsetRight2 = null;
      this.sets.styles.nzOffsetTop2 = null;
      this.sets.styles.nzOffsetBottom2 = null;
      this.sets.styles.nzShow2 = false;
      this.sets.versionCode = 7;
    }





  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.autoUpdate();
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening()
      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
        this.autoUpdate();
      }
    }

    this.Listening();
    // let data = new Date().getTime();
    // console.log('data', data, (data + '').substring((data + '').length - 6, (data + '').length));



  }

  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(data => {
        switch (data['type']) {
          case '':
            break;
          default:
            break;
        }
      }
      )
    }, 100);

  }
  open = false;
  open2 = false;
  failList = [];
  Listening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid);
      this.setService.events[this.blockid].subscribe(
        data => {
          console.log("Listening:", data['type'], JSON.stringify(data));
          switch (data['type']) {

            case 'addLogs':
              this.addLogs(data);
              break;
            case 'addLogs2':
              this.addLogs2(data);
              break;

            default:
              break;
          }
        }
      )
    }, !this.static ? 100 : 0);


  }
  checkChild(id) {
    console.log('id', id);
    this.source = this.oldSource.filter(value => value['fatherId'] == id);
  }
  addLogs2(data) {
    this.source2.splice(0, 0, data['datas']['datas']);
    if (this.open == false)
      this.open = true;
  }
  addLogs(data) {
    if (this.sets.styles.nzNeedClear) {
      this.oldSource = [];
      this.source = [];
      this.failList = [];
    }
    let checkFather = true, success = true, fatherId = data['datas']['fatherLogId'];
    
    if (!this.sets.styles.nzShow2 || fatherId === '') {
      checkFather = false;
    }
    console.log('checkFather',checkFather,fatherId)
    console.log("typeof ", typeof data['datas']['datas'], ",", data['datas']['datas'])
    if (typeof data['datas']['datas'] == "string") {
      data['datas']['datas'] = JSON.parse(data['datas']['datas']);
    }
    data['datas']['datas'].forEach(element => {
      if (checkFather) {
        element['fatherId'] = fatherId
      }
      if (element['controlContent'] !== undefined) {
        try {
          if (this.sets.datas.nzLinkage.nzUsed) {
            this.sets.datas.nzLinkage.nzEvents.forEach(Linkelement => {
              console.log("element-联动", JSON.stringify(Linkelement));
              this.setService.sendEvent(Linkelement.blockid, "linkage" + Linkelement.type, { value: element['controlContent'][Linkelement.key] })
            });
          }
        } catch (error) {

        }
      }
      element['defaultTitle'] = data['datas']['sets']['defaultTitle']

      console.log("element:", element, this.isVisible);
      this.oldSource.splice(0, 0, element);
      // this.source.splice(0, 0, element);
      console.log("this.statusData:", element, this.statusData[element.state]);
      if (element['noticeType'] !== undefined && element['noticeType'] === 'alert') {
        this.failList.splice(0, 0, element);
        if (!this.isVisible) this.isVisible = true;
      }


      if (this.oldSource.length > 1000) {

        this.oldSource.splice(-1, 1);
      }
      if (element.state == 'fail') {
        success = false;
      }
      console.log("addLogs-element", element)
    });
    console.log("addLogs-source", this.oldSource)
    this.changeType(this.nzTypeItem)
    if (checkFather) {
      for (let index = 0; index < this.source2.length; index++) {
        const element = this.source2[index];
        if (element.id === fatherId) {
          element.state = success ? 'success' : 'fail';
          console.log('checkFather',fatherId,element)
          break;
        }
      }
    }
    if (this.open == false)
      this.open = true;
  }

  ngOnDestroy() {
    this.setService.deleteEvent(this.blockid);	//注销	
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
  }

  oldSource = [
  ]
  changeType(item) {
    this.nzTypeItem = item;
    if (item.label != "全部")
      this.source = this.oldSource.filter(value => value['state'] == item.value);
    else {
      this.source = [...this.oldSource];
    }

  }

  clear() {
    this.source = [];
    this.oldSource = [];
    this.failList = [];
  }
  clear2() {
    this.source2 = [];
  }

  isVisible = false;


  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    console.log('Button ok clicked!');
    this.failList = [];
    this.isVisible = false;
  }

  handleCancel(): void {
    console.log('Button cancel clicked!');
    this.failList = [];
    this.isVisible = false;
  }
}
